
// @ts-nocheck


export const localeCodes =  [
  "zh_CN",
  "zh_HK",
  "en_US"
]

export const localeLoaders = {
  "zh_CN": [{ key: "../src/res/i18n/zh_CN.ts", load: () => import("../src/res/i18n/zh_CN.ts" /* webpackChunkName: "locale__Users_guojialin_Workspace_FE_rm_vue_tailwind_src_res_i18n_zh_CN_ts" */), cache: true }],
  "zh_HK": [{ key: "../src/res/i18n/zh_HK.ts", load: () => import("../src/res/i18n/zh_HK.ts" /* webpackChunkName: "locale__Users_guojialin_Workspace_FE_rm_vue_tailwind_src_res_i18n_zh_HK_ts" */), cache: true }],
  "en_US": [{ key: "../src/res/i18n/en_US.ts", load: () => import("../src/res/i18n/en_US.ts" /* webpackChunkName: "locale__Users_guojialin_Workspace_FE_rm_vue_tailwind_src_res_i18n_en_US_ts" */), cache: true }]
}

export const vueI18nConfigs = [
  () => import("../i18n.config.ts?hash=bffaebcb&config=1" /* webpackChunkName: "i18n_config_bffaebcb" */)
]

export const nuxtI18nOptions = {
  "experimental": {
    "localeDetector": "",
    "switchLocalePathLinkSSR": false,
    "autoImportTranslationFunctions": false
  },
  "bundle": {
    "compositionOnly": true,
    "runtimeOnly": false,
    "fullInstall": true,
    "dropMessageCompiler": false
  },
  "compilation": {
    "jit": true,
    "strictMessage": true,
    "escapeHtml": false
  },
  "customBlocks": {
    "defaultSFCLang": "json",
    "globalSFCScope": false
  },
  "vueI18n": "",
  "locales": [
    {
      "code": "zh_CN",
      "language": "zh-CN",
      "name": "中文",
      "files": [
        "/Users/guojialin/Workspace/FE/rm-vue-tailwind/src/res/i18n/zh_CN.ts"
      ]
    },
    {
      "code": "zh_HK",
      "language": "zh-HK",
      "name": "繁體中文-香港",
      "files": [
        "/Users/guojialin/Workspace/FE/rm-vue-tailwind/src/res/i18n/zh_HK.ts"
      ]
    },
    {
      "code": "en_US",
      "language": "en-US",
      "name": "English-US",
      "files": [
        "/Users/guojialin/Workspace/FE/rm-vue-tailwind/src/res/i18n/en_US.ts"
      ]
    }
  ],
  "defaultLocale": "zh_CN",
  "defaultDirection": "ltr",
  "routesNameSeparator": "___",
  "trailingSlash": false,
  "defaultLocaleRouteNameSuffix": "default",
  "strategy": "no_prefix",
  "lazy": true,
  "langDir": "res/i18n/",
  "detectBrowserLanguage": {
    "alwaysRedirect": false,
    "cookieCrossOrigin": false,
    "cookieDomain": null,
    "cookieKey": "lang",
    "cookieSecure": false,
    "fallbackLocale": "",
    "redirectOn": "no prefix",
    "useCookie": true
  },
  "differentDomains": false,
  "baseUrl": "",
  "dynamicRouteParams": false,
  "customRoutes": "page",
  "pages": {},
  "skipSettingLocaleOnNavigate": false,
  "types": "composition",
  "debug": false,
  "parallelPlugin": false,
  "multiDomainLocales": false,
  "i18nModules": []
}

export const normalizedLocales = [
  {
    "code": "zh_CN",
    "language": "zh-CN",
    "name": "中文",
    "files": [
      {
        "path": "/Users/guojialin/Workspace/FE/rm-vue-tailwind/src/res/i18n/zh_CN.ts"
      }
    ]
  },
  {
    "code": "zh_HK",
    "language": "zh-HK",
    "name": "繁體中文-香港",
    "files": [
      {
        "path": "/Users/guojialin/Workspace/FE/rm-vue-tailwind/src/res/i18n/zh_HK.ts"
      }
    ]
  },
  {
    "code": "en_US",
    "language": "en-US",
    "name": "English-US",
    "files": [
      {
        "path": "/Users/guojialin/Workspace/FE/rm-vue-tailwind/src/res/i18n/en_US.ts"
      }
    ]
  }
]

export const NUXT_I18N_MODULE_ID = "@nuxtjs/i18n"
export const parallelPlugin = false
export const isSSG = false

export const DEFAULT_DYNAMIC_PARAMS_KEY = "nuxtI18n"
export const DEFAULT_COOKIE_KEY = "i18n_redirected"
export const SWITCH_LOCALE_PATH_LINK_IDENTIFIER = "nuxt-i18n-slp"
